import { Box, Button } from '@mui/material';
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import Layout from './Layout';
import AuthHead from './authhead';
import { BtnInput, PasswordInput } from './inputs';
import { ArrowBack } from '@mui/icons-material';
import { useChangeAuthType } from '@/util/hooks/changeAuth';

export default function PasswordReset() {
    const {classes}=styles();
     const changeAuthType = useChangeAuthType();
  return (
    <Layout image='/images/explore/explore.svg'>
 <Box className={`${classes.container}`}>
 <AuthHead action="Reset Password" description='Enter the new password'/>
 <Box className={classes.input}>
 <PasswordInput/>
 <PasswordInput name='New Password' placeholder='Confirm New Password'/>
 <BtnInput name={'Save New Password'}/>
 <Button startIcon={<ArrowBack/>} onClick={()=>changeAuthType('login')}>
 Go back to the log in page
 </Button>
 </Box>
 </Box>
</Layout>
   
  )
}

const styles=makeStyles()((theme)=>({
    container:{
      backgroundColor:theme.colors.white,
      display:'flex',
      flexDirection:'column',
     width:'80%',
     gap:theme.spacing(3) 
    },
    debug:{
        border:'1px solid green'
    },
    input:{
      display:'flex',
      flexDirection:'column',
      gap:theme.spacing(3) 
    }
}))